import classnames from 'classnames';
import { observer } from 'mobx-react';
import React, { Component } from 'react';

import InputRadio from '../../../shared/components/InputRadio/InputRadio';
import { PaymentWidgetProps } from '../IPaymentMethod';
import { KlarnaPaymentMethod } from './KlarnaPaymentMethod';
import css from './KlarnaPaymentMethod.css';

@observer
export default class KlarnaPaymentWidget extends Component<PaymentWidgetProps<KlarnaPaymentMethod>, {}> {
  componentDidMount() {
    this.props.paymentMethod.onWidgetRendered();
  }

  render() {
    const {
      translation,
      paymentMethod: { categories, selectedCategory, setSelectedCategory },
    } = this.props;

    return (
      <div>
        {translation.paymentMethods.klarna.selectPaymentCategory}
        <div className={css.container}>
          {categories.map((category) => {
            const isChecked = category.identifier === selectedCategory?.identifier;
            return (
              <InputRadio
                id={category.identifier}
                className={classnames(css.input, { [css.checked]: isChecked })}
                classNameLabel={css.label}
                name={category.name}
                value={category.identifier}
                checked={isChecked}
                onChange={() => setSelectedCategory(category)}
                key={category.identifier}
              >
                <span>{category.name}</span>
                <img className={css.text} src={category.asset_urls.standard} alt={category.name} />
              </InputRadio>
            );
          })}
        </div>
        <div id="klarna_container" />
      </div>
    );
  }
}
